export function clearGlobalFetchAccountTokenPromise(): void {
  (window as any).fetchAccountTokenPromiseId = null;
  (window as any).fetchAccountTokenPromise = null;
}
